/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q2_AnswerInputs */

const en_home_faq_q2_answer = /** @type {(inputs: Home_Faq_Q2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can call our 24/7 assistance line when an emergency occurs. Our Canadian case managers coordinate care and guide you through every step of the claim. Otherwise, you can create an account, login and file a claim there.`)
};

const fr_home_faq_q2_answer = /** @type {(inputs: Home_Faq_Q2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez appeler notre ligne d'assistance 24/7 lorsqu'une urgence survient. Nos gestionnaires de dossiers canadiens coordonnent les soins et vous guident à chaque étape de la réclamation. Sinon, vous pouvez créer un compte, vous connecter et soumettre une réclamation en ligne.`)
};

/**
* | output |
* | --- |
* | "You can call our 24/7 assistance line when an emergency occurs. Our Canadian case managers coordinate care and guide you through every step of the claim. Oth..." |
*
* @param {Home_Faq_Q2_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q2_answer = /** @type {((inputs?: Home_Faq_Q2_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q2_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q2_answer(inputs)
	return fr_home_faq_q2_answer(inputs)
});